import { AppBar, Toolbar } from '@mui/material';

export default function CustomAppBar({
  children,
}) {
  return (
    <AppBar sx={{ background: 'white', position: 'fixed' }}>
      <Toolbar>
        {children}
      </Toolbar>
    </AppBar>
  );
}
